// extracted by mini-css-extract-plugin
export default {"column_width":"UserMessages_column_width__tEOi1","messages_chart":"UserMessages_messages_chart__eEhbW"};